// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimHistoryClaimTypesCriteria from './claim-types-criteria';
import ClaimHistoryCreditMemoDate from './date-criteria';
import ClaimHistoryWorkOrderCriteria from './work-order-criteria';
import Criteria from '../../state/criteria';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import DealerDropdown from '../../../../claim/shared/components/claim-fields/responsible-accounts';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import PinCriteria from './pin-criteria';

const doNothing = () => ({});

const ClaimHistoryInputCriteria = props =>
    <div className='claim-history-input-criteria'>
        <div className='row'>
            <PinCriteria
                handlePinInputChange={props.handlePinInputChange}
                pinValue={props.criteria.pin}
            />
            <ClaimHistoryWorkOrderCriteria
                handleInputChange={props.handleFirstWorkOrderInput}
                label='WORK_ORDER_ONE'
                placeHolderText='WORK_ORDER_ONE'
                value={props.criteria.workOrderOne}
            />
        </div>
        <div className='row'>
            <ClaimHistoryCreditMemoDate
                dateRange={props.criteria.creditMemoProcessDate}
                label='CREDIT_MEMO_PROCESS_DATE'
                onDateChange={props.handleCreditMemoDateSelect}
            />
            <ClaimHistoryWorkOrderCriteria
                handleInputChange={props.handleSecondWorkOrderInput}
                label='WORK_ORDER_TWO'
                placeHolderText='WORK_ORDER_TWO'
                value={props.criteria.workOrderTwo}
            />
        </div>
        <div className='row'>
            <ClaimHistoryClaimTypesCriteria
                claimTypes={props.claimTypes}
                handleClaimTypeSelect={props.handleClaimTypeSelect}
                selectedClaimType={props.criteria.claimType}
            />
            <DealerDropdown
                dealers={props.allowedDealers}
                errorMessage='DEALER_LOCATION_IS_REQUIRED'
                isEditable={true}
                isValid={true}
                onOptionBlur={doNothing}
                onOptionChange={props.handleDealerLocationChange}
                selectedAccount={props.criteria.selectedDealer}
            />
        </div>
    </div>;

ClaimHistoryInputCriteria.displayName = 'ClaimHistoryInputCriteria';
ClaimHistoryInputCriteria.propTypes = {
    allowedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    claimTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair).isRequired),
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    handleClaimTypeSelect: PropTypes.func.isRequired,
    handleCreditMemoDateSelect: PropTypes.func.isRequired,
    handleDealerLocationChange: PropTypes.func.isRequired,
    handleFirstWorkOrderInput: PropTypes.func.isRequired,
    handlePinInputChange: PropTypes.func.isRequired,
    handleSecondWorkOrderInput: PropTypes.func.isRequired
};

export default ClaimHistoryInputCriteria;



// WEBPACK FOOTER //
// ./src/reports/claim-history/components/claim-history-report-criteria/input-criteria.js